import type { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { AvaliacaoComponent } from '../../components/360-feedback'

export default function Avaliacao() {
  return <AvaliacaoComponent />
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || 'pt', [
        'avaliacao360',
        'common',
      ])),
    },
  }
}
